import "./footer.css"

const Footer =() => {
    return(
        <footer>
            <p>&copy; 2023</p>
            <p><a href="mailto:jiwebdeveloping@gmail.com" >JIwebdeveloping</a></p>
        </footer>
    )
}
export default Footer